class ProductGallery extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      thumbnailsContainer: '[js-gallery-thumbnails]',
      thumbnail: '[js-gallery-thumbnail-slide]',
      mainCarousel: '[js-gallery-main]',
      mainCarouselWrapper: '[js-gallery-main-wrapper]',
      targetSlideBtn: '[js-navigate-slide]',
      nextSlideBtn: '[js-gallery-next-btn]',
      prevSlideBtn: '[js-gallery-prev-btn]',
      slideZoom: '[js-carousel-zoom]',
      zoomModal: '[js-carousel-zoom-modal]',
      magic360Shortcut: '[js-magic360-shortcut]',
    }
    this._selectors.inlinePlayButton = '[js-inline-play-button]';
    this._selectors.videoPoster = '[js-video-poster]';
    this._selectors.videoWrapper = '[js-video-wrapper]';
    this._selectors.videoSlide = '.swiper-slide--video';

    this._selectors.videoPlaceholder = '.video-placeholder';
    this.movedVideoPlayers = []; // To store details of all moved videos

    this.thumbnails = this.querySelectorAll(this._selectors.thumbnail)
    this.mainCarousel = this.querySelector(this._selectors.mainCarousel)
    this.mainCarouselWrapper = this.querySelector(this._selectors.mainCarouselWrapper)

    this.nextSlideBtn = this.querySelector(this._selectors.nextSlideBtn)
    this.prevSlideBtn = this.querySelector(this._selectors.prevSlideBtn)
    this.targetSlideBtn = this.querySelectorAll(this._selectors.targetSlideBtn)
    this.thumbnailsContainer = this.querySelector(this._selectors.thumbnailsContainer)
    this.currentSlide = 0
    this.magic360Shortcut = this.querySelector(this._selectors.magic360Shortcut + ' button')

    this.slideZooms = this.querySelectorAll(this._selectors.slideZoom)
    this.zoomModal = document.querySelector(this._selectors.zoomModal)

    this.zoomImages = this.zoomModal.querySelectorAll('.modal-gallery__content__image')

    // Custom Carousel Logic due to buggy vertical sliders
    this.isDragging = false;
    this.hasMoved = false;
    this.startPos = 0;
    this.scrollStartPos = 0;
    this.boundHandleMouseMove = this.handleMouseMove.bind(this);

    // Logic to distinguish between mobile vs desktop thumbnail layout
    // Determines which direction to scroll the thumbnails in
    const isWideScreen = window.innerWidth > 1279;

    this.thumbnailDirection = {
      offset: isWideScreen ? "offsetTop" : "offsetLeft",
      scrollAxis: isWideScreen ? "scrollTop" : "scrollLeft",
      scrollDimensions: isWideScreen ? "scrollHeight" : "scrollWidth",
      page: isWideScreen ? "pageY" : "pageX",
      direction: isWideScreen ? "top" : "left",
    }

    window.addEventListener("resize", () => {
      const isWideScreen = window.innerWidth > 1279;

      this.thumbnailDirection = {
        offset: isWideScreen ? "offsetTop" : "offsetLeft",
        scrollAxis: isWideScreen ? "scrollTop" : "scrollLeft",
        scrollDimensions: isWideScreen ? "scrollHeight" : "scrollWidth",
        page: isWideScreen ? "pageY" : "pageX",
        direction: isWideScreen ? "top" : "left",
      }
    });
  }

  prepareVideoForModal(slide) {
      const videoWrapper = slide.querySelector(this._selectors.videoWrapper);
      
      // --- FIX: Corrected logic and removed stray semicolon ---
      if (!videoWrapper) return;
  
      // Check if the video is currently hidden (i.e., showing the poster image)
      if (videoWrapper.hidden) {
          // If the video player isn't active, we just need to know where it will live.
          // We find the player inside the hidden wrapper to prepare it for the move.
          this.videoOriginalParent = videoWrapper;
          this.activeVideoPlayer = videoWrapper.querySelector('iframe, video');
      } else {
          // If the video is already playing inline, the wrapper is visible.
          this.videoOriginalParent = videoWrapper;
          this.activeVideoPlayer = videoWrapper.firstElementChild; // The playing video/iframe
      }
  }
  
  handleModalToggle(mutations) {
    mutations.forEach((mutation) => {
        if (mutation.attributeName === 'open') {
            const modal = mutation.target;
            if (modal.hasAttribute('open')) {
                // Modal is opening: Move all videos into their modal placeholders.
                this.moveAllVideosToModal();
            } else {
                // Modal is closing: Return all videos to the carousel.
                this.returnAllVideosFromModal();
            }
        }
    });
}

moveAllVideosToModal() {
    const placeholders = this.zoomModal.querySelectorAll(this._selectors.videoPlaceholder);
    placeholders.forEach(placeholder => {
        const mediaId = placeholder.dataset.mediaId;
        const carouselVideoSlide = this.querySelector(`.swiper-slide--video[data-media-id="${mediaId}"]`);
        if (!carouselVideoSlide) return;

        const videoWrapper = carouselVideoSlide.querySelector(this._selectors.videoWrapper);
        const player = videoWrapper.querySelector('iframe, video');

        if (player) {
            // Check if the video was playing inline *before* we move it.
            const wasPlayingInline = !videoWrapper.hidden;

            this.movedVideoPlayers.push({
                player: player,
                originalParent: videoWrapper
            });
            
            placeholder.appendChild(player);

            // After moving the player, if it was playing, ensure it autoplays in the modal.
            // Since moving an iframe reloads it, we add the autoplay=1 parameter to its URL.
            if (wasPlayingInline && player.tagName === 'IFRAME') {
                if (!player.src.includes('autoplay=1')) {
                    player.src += (player.src.includes('?') ? '&' : '?') + 'autoplay=1';
                }
            } else if (wasPlayingInline && player.tagName === 'VIDEO') {
                player.play();
            }
        }
    });
}

returnAllVideosFromModal() {
    this.movedVideoPlayers.forEach(item => {
        // Move the player back to its original parent in the carousel
        item.originalParent.appendChild(item.player);
    });
    // Clear the array for the next time the modal is opened
    this.movedVideoPlayers = [];
}
  
  // Add this method to the ProductGallery class
  disconnectedCallback() {
      if (this.modalObserver) {
          this.modalObserver.disconnect();
      }
  }

  connectedCallback() {
    const slideLimit = Number(this.mainCarouselWrapper.getAttribute('data-slide-limit'))
 
    this.mainCarousel.swiper.on('slideChange', (evt) => {
        const activeIndex = evt.activeIndex;
 
        if (activeIndex !== this.selectedIndex) {
            this.selectSlide(activeIndex)
        }
        function updateCountdownVisibility() {
            var countdownDisplay = document.querySelector('.product_gallery__main__countdown');
            var mobileTitle = document.querySelector('.product__main__title.mobile-only');
            if (countdownDisplay && mobileTitle) {
                var isMobile = getComputedStyle(mobileTitle).display === 'none';
                if (isMobile) {
                    countdownDisplay.style.display = (activeIndex === 0) ? 'block' : 'none';
                } else {
                    countdownDisplay.style.display = 'block';
                }
            }
        }
        updateCountdownVisibility();
        window.addEventListener('resize', updateCountdownVisibility);
        this.mainCarouselWrapper.setAttribute('data-current-slide', activeIndex)
        if (this.magic360Shortcut) this.handleMagic360Shortcut(activeIndex, slideLimit)
        if (activeIndex === slideLimit) {
            this.mainCarouselWrapper.classList.add('slider-end-reached')
        } else if (this.mainCarouselWrapper.classList.contains('slider-end-reached')) {
            this.mainCarouselWrapper.classList.remove('slider-end-reached')
        }
        this.pauseExitedVideo(evt);
    });
 
    this.nextSlideBtn.addEventListener('click', () => {
        this.mainCarousel.swiper.slideNext()
    });
 
    this.prevSlideBtn.addEventListener('click', () => {
        this.mainCarousel.swiper.slidePrev()
    });

    /*
    // This is the debugging block for the zoom button click.
    this.slideZooms.forEach((zoom) => {
        zoom.addEventListener('click', (evt) => {
            console.clear();
            console.log("--- ZOOM BUTTON CLICKED ---");
            const slide = evt.currentTarget.closest('.swiper-slide');
            const customIndex = evt.currentTarget.getAttribute('data-index');
            console.log("The button's 'data-index' is:", customIndex);
            if (slide) {
                console.log("The carousel slide's internal index ('data-swiper-slide-index') is:", slide.dataset.swiperSlideIndex);
            }
            console.log("---------------------------");

            // Original function call
            this.selectZoomImage(customIndex); 
        });
    });
    */

    // Replace the existing slideZooms listener with this final version.
    this.slideZooms.forEach((zoom) => {
        zoom.addEventListener('click', (evt) => {
            // Get the index from the button that was clicked.
            let originalIndex = parseInt(evt.currentTarget.getAttribute('data-index'), 10);
    
            if (isNaN(originalIndex)) return;
    
            let correctedIndex = originalIndex; // Start with the original index.
    
            // --- START: Mobile Index Correction Logic ---
            
            const isMobileView = window.innerWidth < 990; // The mobile breakpoint
            const featuresSlide = document.getElementById('product-features-mobile-slide');
            
            // This logic runs only on mobile, AND only if the special features slide exists.
            if (isMobileView && featuresSlide) {
                
                // Get all the slides currently in the carousel to find the position of our special slide.
                const allSlidesInCarousel = Array.from(featuresSlide.parentElement.children);
                const featuresSlideIndex = allSlidesInCarousel.indexOf(featuresSlide);
    
                // This is the key: If the button we clicked belongs to a slide that comes *after*
                // the special mobile-only slide, we must subtract 1 from its index to match
                // the modal's list of items (which doesn't have the features slide).
                // We compare the button's index to the feature slide's actual position.
                if (featuresSlideIndex > -1 && originalIndex >= featuresSlideIndex) {
                    correctedIndex = originalIndex - 1;
                }
            }
            // --- END: Mobile Index Correction Logic ---
    
            // Use the (now corrected) index to show the right slide in the modal.
            this.selectZoomImage(correctedIndex);
        });
    });
 
    if (this.zoomModal) {
        this.modalObserver = new MutationObserver(this.handleModalToggle.bind(this));
        this.modalObserver.observe(this.zoomModal, { attributes: true, attributeFilter: ['open'] });
    }
 
    this.targetSlideBtn.forEach((btn) => btn.addEventListener('click', (evt) => {
        const targetIndex = Number(btn.getAttribute('data-slide-target'))
        this.mainCarousel.swiper.slideTo(targetIndex)
    }));
 
    this.initInlineVideo();
    this.initDragOrClick();
  }

  handleMagic360Shortcut(activeIndex, slideLimit) {
    if (activeIndex === slideLimit) {
      this.magic360Shortcut.innerHTML = 'View Image Gallery'
      this.magic360Shortcut.setAttribute('data-slide-target', 0)
    } else {
      this.magic360Shortcut.innerHTML = 'View 360°'
      this.magic360Shortcut.setAttribute('data-slide-target', slideLimit)
    }
  }

  selectZoomImage(index) {
    const numericIndex = parseInt(index, 10);

    // Safety check to ensure the index is valid and the element exists.
    if (isNaN(numericIndex) || !this.zoomImages[numericIndex]) {
        console.error('selectZoomImage called with an invalid or out-of-bounds index:', index);
        return;
    }

    const selectedImage = this.zoomImages[numericIndex];
    const modalGalleryContentInfo = this.zoomModal.querySelector('.modal-gallery__content-info');

    if (!modalGalleryContentInfo) {
        console.error('Could not find the modal scrolling container.');
        return;
    }

    // --- The Fix ---
    // The modal gallery always scrolls vertically. The previous code was incorrectly
    // trying to scroll horizontally (`scrollLeft`) on mobile.
    // This corrected code ALWAYS sets the vertical scroll position (`scrollTop`)
    // to the target element's vertical position (`offsetTop`).
    modalGalleryContentInfo.scrollTop = selectedImage.offsetTop;
  }

  selectSlide(selectedIndex, setMainCarousel = false) {
    this.currentSlide = selectedIndex

    this.thumbnails.forEach((thumbnail) => {
      if (thumbnail !== this.thumbnails[selectedIndex] && thumbnail.classList.contains('selected')) {
        thumbnail.classList.remove('selected')
      } else if (thumbnail === this.thumbnails[selectedIndex] && !thumbnail.classList.contains('selected')) {
        thumbnail.classList.add('selected')
      }
    })

    if (setMainCarousel) {
      this.mainCarousel.swiper.slideTo(selectedIndex)
    }

    const selectedSlide = this.thumbnails[selectedIndex]

    if (selectedSlide.getAttribute('data-magic360') === 'true') {
      this.scrollToLastThumbnail()
    } else {
      this.scrollToActiveThumbnail()
    }

    this.checkNavState(selectedIndex)
  }

  checkNavState(selectedIndex) {
    if (selectedIndex == this.thumbnails.length - 1) {
      this.nextSlideBtn.setAttribute('disabled', true)
    } else if (this.nextSlideBtn.getAttribute('disabled') == 'true') {
      this.nextSlideBtn.removeAttribute('disabled')
    }

    if (selectedIndex >= 1 && this.prevSlideBtn.getAttribute('disabled') == 'true') {
      this.prevSlideBtn.removeAttribute('disabled')
    } else if (selectedIndex == 0) {
      this.prevSlideBtn.setAttribute('disabled', true)
    }
  }

  observeActiveThumbnail() {
    // Observer setup to auto-scroll to the active thumbnail
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          this.scrollToActiveThumbnail()
        }
      })
    })

    this.thumbnails.forEach((thumbnail) => {
      observer.observe(thumbnail, {
        attributes: true, // Listen for attribute changes
        attributeFilter: ['class'], // Specifically for class changes
      })
    })
  }

  scrollToLastThumbnail() {
    this.thumbnailsContainer.scrollTo({
      [this.thumbnailDirection.direction]: this.thumbnailsContainer[this.thumbnailDirection.scrollDimensions],
      behavior: 'smooth',
    });
  }

  scrollToActiveThumbnail() {
    const activeThumbnail = this.querySelector(`${this._selectors.thumbnail}.selected`)

    if (activeThumbnail) {
      this.thumbnailsContainer.scrollTo({
        [this.thumbnailDirection.direction]: activeThumbnail[this.thumbnailDirection.offset] - this.thumbnailsContainer[this.thumbnailDirection.offset],
        behavior: 'smooth',
      })
    }
  }

  initDragOrClick() {

    this.thumbnailsContainer.addEventListener('mousedown', (e) => {
      e.preventDefault(); // Prevent default action to avoid dragging images or selecting text
      this.isDragging = false; // Assume it's not dragging initially
      this.hasMoved = false; // Reset moved state
      this.startPos = e[this.thumbnailDirection.page];
      this.scrollStartPos = this.thumbnailsContainer[this.thumbnailDirection.scrollAxis];
      document.addEventListener('mousemove', this.boundHandleMouseMove);
    });

    document.addEventListener('mouseup', (e) => {
      document.removeEventListener('mousemove', this.boundHandleMouseMove);
      this.isDragging && e.preventDefault(); // Prevent click event if it was a drag
      this.isDragging = false;
    });

    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', (e) => {
        !this.hasMoved ? this.handleClick(thumbnail) : e.stopImmediatePropagation();
      });
    });

  }

  handleMouseMove(e) {
    if (Math.abs(e[this.thumbnailDirection.page] - this.startPos) > 5 && !this.isDragging) {
      this.isDragging = true;
      this.thumbnailsContainer.style.userSelect = 'none';
      this.thumbnailsContainer.style.cursor = 'grabbing';
    }
    if (this.isDragging) {
      this.hasMoved = true; // Flag as moved for click handler check
      this.thumbnailsContainer[this.thumbnailDirection.scrollAxis] = this.scrollStartPos - (e[this.thumbnailDirection.page] - this.startPos);
    }
  }

  handleClick(thumbnail) {
    const selectedIndex = Number(thumbnail.getAttribute('data-index'));
    this.selectSlide(selectedIndex, true);
  }

  initInlineVideo() {
      this.querySelectorAll(this._selectors.inlinePlayButton).forEach(button => {
          button.addEventListener('click', this.playInlineVideo.bind(this));
      });
  }
  
  playInlineVideo(event) {
      event.preventDefault();
      const playButton = event.currentTarget;
      const slide = playButton.closest(this._selectors.videoSlide);
      if (!slide) return;
  
      const poster = slide.querySelector(this._selectors.videoPoster);
      const videoWrapper = slide.querySelector(this._selectors.videoWrapper);
  
      // If the video wrapper doesn't exist, stop here to prevent an error.
      if (!videoWrapper) {
          console.error('Product Gallery: Video wrapper not found in this slide.', slide);
          return;
      }
  
      const iframe = videoWrapper.querySelector('iframe');
      const video = videoWrapper.querySelector('video');
  
      if (poster) poster.classList.add('video-poster--hidden');
      videoWrapper.hidden = false;
  
      // Autoplay embedded videos
      if (iframe && !iframe.src.includes('autoplay=1')) {
          iframe.src += (iframe.src.includes('?') ? '&' : '?') + 'autoplay=1';
      } else if (video) {
          video.play();
      }
  }
  
  pauseExitedVideo(swiperEvent) {
      const previousSlide = swiperEvent.slides[swiperEvent.previousIndex];
      
      if (previousSlide && previousSlide.classList.contains('swiper-slide--video')) {
          const poster = previousSlide.querySelector(this._selectors.videoPoster);
          const videoWrapper = previousSlide.querySelector(this._selectors.videoWrapper);
  
          // If video isn't playing, do nothing
          if (!videoWrapper || videoWrapper.hidden) return; 
          
          const iframe = videoWrapper.querySelector('iframe');
          const video = videoWrapper.querySelector('video');
  
          // Stop/pause the video and reset the slide to its initial state
          if (iframe) {
              // Re-setting the src is the most reliable way to stop an iframe video
              iframe.src = iframe.src.replace('&autoplay=1', '').replace('?autoplay=1', '');
          } else if (video) {
              video.pause();
          }
  
          videoWrapper.hidden = true;
          if (poster) poster.classList.remove('video-poster--hidden');
      }
  }

}

if (!customElements.get('product-gallery')) {
  customElements.define("product-gallery", ProductGallery);
}